export default function getIdFromIri(iri) {
  if (typeof iri !== 'string' || !iri.startsWith('/')) {
    return iri;
  }

  return iri.split('/').reverse()[0];
}
